import { IEditController } from "../../../../shared/components/edit-table/edit-table";
import { DataViewer, DataViewType } from "../../../../shared/components/edit-table/data-viewer";
import { ViewModal, ViewModalConfig, ViewModalTable} from "../../../../shared/components/edit-table/view-modal";
import { CppForm } from "../../../../shared/entities/cpp-form/cpp-form";
import { CppTableController, CppProgramReviewController, CppScientificReviewController, CppAdminController } from "./cpp-dashboard.controller";
import _ from "lodash";
import { CppReviewModal } from "./cpp-dashboard.modal";
import { WebForm } from "../../../../shared/components/web-form/web-form";
import { DropdownInputField, DropdownInputOptions, FormSection } from "../../../../shared/components/web-form/web-form.objects";
import { RevisionCommentInput, RevisionCommentOptions } from "./form-fields/revision-comment-field";
export class CppDashboardPage implements IEditController {
    userId: number;
    userRole: number; // 1 = User, 2 = SO, 3 = PO, 4 = Admin

    tableController: CppTableController;
    scienceOfficerController: CppScientificReviewController;
    programOfficerController: CppProgramReviewController;
    adminFormController: CppAdminController;
    viewModal: ViewModal;
    scienceReviewModal: CppReviewModal;
    programReviewModal: CppReviewModal;
    adminReviewModal: CppReviewModal;

    constructor(userId: any, userRole: any) {
        $(() => {
            this.userId = userId;
            this.userRole = userRole;

            this.tableController = new CppTableController("cpp-form-table-content", this)
            this.scienceOfficerController = new CppScientificReviewController(this.tableController);
            this.programOfficerController = new CppProgramReviewController(this.tableController);
            this.adminFormController = new CppAdminController(this.tableController);
            this.initialize();
        });
    }

    async initialize(): Promise<void> {
        this.viewModal = new ViewModal({
            modalId: "view-submission-modal",
            displayName: "CPP Proposal",
            filename: "cpp_submission",
            getPrintTitle: (obj) => {
                let title = _.get(obj, "ProjectTitle");
                if (!title) {
                    title = "CPP Proposal"
                }
                return title;
            },
            viewTables: [
                new ViewModalTable("CPP Proposal Information", [
                    new DataViewer("ProjectTitle", DataViewType.String, "CPP Title"),
                    new DataViewer("AppUserId", DataViewType.NumberId, "Submitter", "pl-user"),
                    new DataViewer("LeadHubId", DataViewType.NumberId, "Lead Hub", "pl-hub"),
                    new DataViewer("CollaboratingHubIds", DataViewType.PipePathSeparatedBullets, "Collaborating Hubs", "pl-hub"),
                    new DataViewer("StatusId", DataViewType.NumberId, "Status", "pl-cpp-status"),
                    new DataViewer("LastSubmitDate", DataViewType.Date, "Submission Date"),
                    new DataViewer("CommunicateUpdatesIds", DataViewType.PipePathSeparatedBullets, "Communicate Updates With", "pl-user"),
                ]),
                new ViewModalTable("CPP Proposal Upload", [
                    new DataViewer("ProposalUploadId", DataViewType.DocumentUpload, "Uploaded PDF", "", "CppForm/ProposalUploadId")
                ])
            ]
        });

        if (this.userRole >= 2) {
            let scienceReviewForm = new WebForm({
                defaultItem: CppForm.getDefault(),
                saveRoute: "",
                formSections: [
                    new FormSection({
                        sectionId: "so-update-status-section",
                        displayName: "Scientific Officer | Update Status",
                        formFields: [
                            new DropdownInputField("StatusId", "so-review-status-input", "Updated Proposal Status", "", true, new DropdownInputOptions("pl-cpp-status-so")),
                            new RevisionCommentInput("RevisionComment", "so-revision-comment", "Revisions Requested", "", true, new RevisionCommentOptions("so-review-status-input", ["2"]))
                        ]
                    })
                ]
            })

            this.scienceReviewModal = new CppReviewModal({
                modalId: "review-submission-modal",
                displayName: "SO | Update Status",
                editController: this.scienceOfficerController,
                webForm: scienceReviewForm,
                viewTables: [
                    new ViewModalTable("CPP Proposal Information", [
                        new DataViewer("ProjectTitle", DataViewType.String, "CPP Title"),
                        new DataViewer("AppUserId", DataViewType.NumberId, "Submitter", "pl-user"),
                        new DataViewer("LeadHubId", DataViewType.NumberId, "Lead Hub", "pl-hub"),
                        new DataViewer("CollaboratingHubIds", DataViewType.PipePathSeparatedBullets, "Collaborating Hubs", "pl-hub"),
                        new DataViewer("StatusId", DataViewType.NumberId, "Status", "pl-cpp-status"),
                        new DataViewer("LastSubmitDate", DataViewType.Date, "Submission Date"),
                        new DataViewer("CommunicateUpdatesIds", DataViewType.PipePathSeparatedBullets, "Communicate Updates With", "pl-user"),
                    ]),
                    new ViewModalTable("CPP Proposal Upload", [
                        new DataViewer("ProposalUploadId", DataViewType.DocumentUpload, "Uploaded PDF", "", "CppForm/ProposalUploadId")
                    ])
                ]
            })
        }
        if (this.userRole >= 3) {
            let programReviewForm = new WebForm({
                defaultItem: CppForm.getDefault(),
                saveRoute: "",
                formSections: [
                    new FormSection({
                        sectionId: "po-update-status-section",
                        displayName: "Program Officer | Update Status",
                        formFields: [
                            new DropdownInputField("StatusId", "po-review-status-input", "Updated Proposal Status", "", true, new DropdownInputOptions("pl-cpp-status-po")),
                            new RevisionCommentInput("RevisionComment", "po-revision-comment", "Revisions Requested", "", true, new RevisionCommentOptions("po-review-status-input", ["2"]))
                        ]
                    })
                ]
            })

            this.programReviewModal = new CppReviewModal({
                modalId: "review-submission-modal",
                displayName: "PO | Update Status",
                editController: this.programOfficerController,
                webForm: programReviewForm,
                viewTables: [
                    new ViewModalTable("CPP Proposal Information", [
                        new DataViewer("ProjectTitle", DataViewType.String, "CPP Title"),
                        new DataViewer("AppUserId", DataViewType.NumberId, "Submitter", "pl-user"),
                        new DataViewer("LeadHubId", DataViewType.NumberId, "Lead Hub", "pl-hub"),
                        new DataViewer("CollaboratingHubIds", DataViewType.PipePathSeparatedBullets, "Collaborating Hubs", "pl-hub"),
                        new DataViewer("StatusId", DataViewType.NumberId, "Status", "pl-cpp-status"),
                        new DataViewer("LastSubmitDate", DataViewType.Date, "Submission Date"),
                        new DataViewer("CommunicateUpdatesIds", DataViewType.PipePathSeparatedBullets, "Communicate Updates With", "pl-user"),
                    ]),
                    new ViewModalTable("CPP Proposal Upload", [
                        new DataViewer("ProposalUploadId", DataViewType.DocumentUpload, "Uploaded PDF", "", "CppForm/ProposalUploadId")
                    ])
                ]
            })
        }
        if (this.userRole == 4) {
            let adminReviewForm = new WebForm({
                defaultItem: CppForm.getDefault(),
                saveRoute: "",
                formSections: [
                    new FormSection({
                        sectionId: "admin-status-section",
                        displayName: "Update Status",
                        formFields: [
                            new DropdownInputField("StatusId", "admin-status-input", "Updated Proposal Status", "To remove this proposal from the system, please update the status to 'Deleted'.", true, new DropdownInputOptions("pl-cpp-status", false, false, false)),
                        ]
                    })
                ]
            })

            this.adminReviewModal = new CppReviewModal({
                modalId: "review-submission-modal",
                displayName: "Admin | Update Status",
                editController: this.adminFormController,
                webForm: adminReviewForm,
                viewTables: [
                    new ViewModalTable("CPP Proposal Information", [
                        new DataViewer("ProjectTitle", DataViewType.String, "CPP Title"),
                        new DataViewer("AppUserId", DataViewType.NumberId, "Submitter", "pl-user"),
                        new DataViewer("LeadHubId", DataViewType.NumberId, "Lead Hub", "pl-hub"),
                        new DataViewer("CollaboratingHubIds", DataViewType.PipePathSeparatedBullets, "Collaborating Hubs", "pl-hub"),
                        new DataViewer("StatusId", DataViewType.NumberId, "Status", "pl-cpp-status"),
                        new DataViewer("LastSubmitDate", DataViewType.Date, "Submission Date"),
                        new DataViewer("CommunicateUpdatesIds", DataViewType.PipePathSeparatedBullets, "Communicate Updates With", "pl-user"),
                    ]),
                    new ViewModalTable("CPP Proposal Upload", [
                        new DataViewer("ProposalUploadId", DataViewType.DocumentUpload, "Uploaded PDF", "", "CppForm/ProposalUploadId")
                    ])
                ]
            })
        }
        this.tableController.initialize();
        this.initializeView();
        this.initializeDocumentCards();
    }

    async saveItems(items: any[], isAdd: boolean): Promise<void> {
        return;
    }

    getEditMenu(): string {
        let menuOptions = "";

        let currentItem: CppForm = this.tableController.editTable.currentTargetItem;

        let viewOption = `<a class="dropdown-item dropdown-view-option" data-id="${currentItem.Id}"><i class="fa-solid fa-magnifying-glass dropdown-icon pr-2"></i> View Proposal</a>`;
        menuOptions += viewOption;

        if (currentItem.StatusId < 3 && this.tableController.editList.some(item => item.Id == currentItem.Id)) {
            let editOption = `<a class="dropdown-item" href="/secure/cpp-proposal-form/${currentItem.Id}"><i class="fa-solid fa-pen-to-square dropdown-icon pr-2"></i> Edit Proposal</a>`
            menuOptions += editOption;
        }
        if (currentItem.StatusId == 3 && this.userRole >= 2) {
            let reviewOption = `<a class="dropdown-item dropdown-review-so-option" data-id="${currentItem.Id}"><i class="fa-solid fa-file-signature dropdown-icon pr-2"></i> SO | Review Proposal</a>`
            menuOptions += reviewOption;
        }
        if (currentItem.StatusId == 4 && this.userRole >= 3) {
            let reviewOption = `<a class="dropdown-item dropdown-review-po-option" data-id="${currentItem.Id}"><i class="fa-solid fa-file-signature dropdown-icon pr-2"></i> PO | Review Proposal</a>`
            menuOptions += reviewOption;
        }
        if (this.userRole == 4) {
            let adminOption = `<hr class="my-1"/><a class="dropdown-item dropdown-status-option" data-id="${currentItem.Id}"><i class="fa-solid fa-user-gear dropdown-icon pr-2"></i> Admin | Update Status</a>`
            menuOptions += adminOption;
        }
        return menuOptions;
    }

    private initializeView(): void {
        $("#cpp-form-table-content").on("click", "a.dropdown-view-option", (e) => {
            let target = $(e.currentTarget);
            let targetId = target.data("id")
            let targetItem = this.tableController.editTable.tableItems.find(item => item.Id.toString() == targetId);
            if (targetItem) {
                this.viewModal.openModal(targetItem, this.tableController.editTable.pickLists);
            }
        });

        if (this.userRole >= 2) {
            $("#cpp-form-table-content").on("click", "a.dropdown-review-so-option", (e) => {
                let target = $(e.currentTarget);
                let targetId = target.data("id")
                let targetItem = this.tableController.editTable.tableItems.find(item => item.Id.toString() == targetId);
                if (targetItem) {
                    this.scienceReviewModal.openModal([targetItem], this.tableController.editTable.pickLists);
                }
            });
        }

        if (this.userRole >= 3) {
            $("#cpp-form-table-content").on("click", "a.dropdown-review-po-option", (e) => {
                let target = $(e.currentTarget);
                let targetId = target.data("id")
                let targetItem = this.tableController.editTable.tableItems.find(item => item.Id.toString() == targetId);
                if (targetItem) {
                    this.programReviewModal.openModal([targetItem], this.tableController.editTable.pickLists);
                }
            });
        }

        if (this.userRole == 4) {
            $("#cpp-form-table-content").on("click", "a.dropdown-status-option", (e) => {
                let target = $(e.currentTarget);
                let targetId = target.data("id")
                let targetItem = this.tableController.editTable.tableItems.find(item => item.Id.toString() == targetId);
                if (targetItem) {
                    this.adminReviewModal.openModal([targetItem], this.tableController.editTable.pickLists);
                }
            });
        }
    }

    private initializeDocumentCards(): void {
        $(".document-card").on("click", (e) => {
            let targetCard = $(e.currentTarget);
            let link = targetCard.data("link");
            let filename = targetCard.data("filename");
            this.viewDocument(filename, link);
        })
    }

    private viewDocument(fileName:string, docLink: string): void {
        let viewDocModal = $("#view-document-modal");
        if (viewDocModal) {
            viewDocModal.find("#filename").text(fileName);
            viewDocModal.find("#document-iframe").attr("src", docLink);
            viewDocModal.modal("show");
        }
    }
}